import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrokerSellerComponent } from './broker-seller.component';
import { SelectInputModule } from '../../inputs/select/select.module';

@NgModule({
    declarations: [BrokerSellerComponent],
    imports: [
        CommonModule,
        SelectInputModule
    ],
    exports: [BrokerSellerComponent]
})
export class BrokerSellerModule { }
